import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import CustomTextareaComponent from "components/Form/CustomTextareaComponent";
import Select from "components/Form/Select";

const schemaValidation = Yup.object().shape({
	cancel_reason: Yup.string().required("Champ requis"),
});

const CancelNurseHelpModal = ({ open, close, cancelFolderHelp, folderId, reasonOptions }) => {
	return (
		<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
			<Modal.Header>Etes-vous sûr de vouloir annuler cet appel à une secrétaire pour encoder les analyses ?</Modal.Header>
			<Formik
				enableReinitialize
				initialValues={{
					folderId: folderId,
					cancel_reason: "",
				}}
				validationSchema={schemaValidation}
				onSubmit={(values) => {
					cancelFolderHelp(values.folderId, values.cancel_reason_comment, values.cancel_reason);
					close();
				}}
			>
				{({ submitForm }) => (
					<>
						<Modal.Content>
							<Form>
								<Field
									component={Select}
									name="cancel_reason"
									customlabel="Veuillez sélectionner la raison de l'annulation."
									placeholder="Raison de l'annulation"
									options={reasonOptions
										.filter((reason) => reason.group === "BYNURSE")
										.map((option) => {
											return {
												value: option.id,
												label: option.label,
											};
										})}
								/>
								<Field component={CustomTextareaComponent} name="cancel_reason_comment" customlabel="Ajoutez un commentaire si besoin." />
							</Form>
						</Modal.Content>

						<Modal.Actions>
							<Button
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									close();
								}}
							>
								Annuler
							</Button>
							<Button
								primary
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									submitForm();
								}}
							>
								Confirmer
							</Button>
						</Modal.Actions>
					</>
				)}
			</Formik>
		</Modal>
	);
};

export default CancelNurseHelpModal;
